export const ASSETS = {
  hero: "https://customer-assets.emergentagent.com/job_46263231-f3be-4a0c-bdf4-e9d9adf460ab/artifacts/0661s4ya_IMG_0348.PNG",
  aboutPortrait: "https://customer-assets.emergentagent.com/job_46263231-f3be-4a0c-bdf4-e9d9adf460ab/artifacts/ck7b6153_IMG_1604.jpg",
  team: "https://customer-assets.emergentagent.com/job_stefanie-sells/artifacts/xm99vijd_Gemini_Generated_Image_l1pzqvl1pzqvl1pz.jpg",
  primoLogo: "/primo-group-logo.png",
  qr: "https://customer-assets.emergentagent.com/job_46263231-f3be-4a0c-bdf4-e9d9adf460ab/artifacts/2ta7wesh_valery-referral-stefaniew.png",
  homeValueUrl: "https://valery.ca?ref=stefaniew",
  interiorBg: "https://images.unsplash.com/photo-1679862342541-e408d4f3ab80?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBpbnRlcmlvciUyMGRlc2lnbiUyMGxpdmluZyUyMHJvb218ZW58MHx8fHwxNzc3OTkwNzc1fDA&ixlib=rb-4.1.0&q=85",
};

export const LINKS = {
  website: "https://www.thepgsells.com",
  email: "stef@stefwinstan.com",
  amazon: "https://a.co/d/0eFv1kXm",
  instagram: "https://www.instagram.com/stefwinstan/?hl=en",
  primoInstagram: "https://www.instagram.com/primogroupottawa/?hl=en",
  linkedin: "https://www.linkedin.com/in/stefanie-winstan/",
  calendly: "https://calendly.com/stefwinstan/30min",
  backstageUGC: "https://www.backstage.com/ugc/stefanie-winstan/",
  backstageModel: "https://www.backstage.com/u/stefanie-winstan/",
};
